var exports = {
  "kL": "AddFriendSheet.module__container___QUNxWD",
  "XG": "AddFriendSheet.module__scroller___QUNxWD",
  "Qs": "AddFriendSheet.module__content___QUNxWD",
  "Y4": "AddFriendSheet.module__requestsSection___QUNxWD",
  "Ic": "AddFriendSheet.module__requestsGroup___QUNxWD",
  "sg": "AddFriendSheet.module__requestsHeader___QUNxWD",
  "vA": "AddFriendSheet.module__requestsList___QUNxWD",
  "Jt": "AddFriendSheet.module__requestDivider___QUNxWD",
};

module.exports = exports;
